import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWireframeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M5 8h10v10H5z" }), /* @__PURE__ */ _jsx("path", {
		d: "M9 4h10v10H9zM5 8l4-4m6 4 4-4M5 18l4-4m6 4 4-4",
		opacity: .4
	})]
});
export default SvgWireframeIcon;
